<template>
  <div class="upload-media-preview">
    <div
      class="upload-media-preview__img preview-img"
      :class="{ 'preview-img--loading': loading }"
    >
      <span class="icon-draggable" />
      <div v-if="validating" class="alert-component-container">
        <div class="alert-component">
          <div class="alert-component__icon" />
          <span class="alert-component__text">{{ trans('form.offer.field.validation') }}</span>
        </div>
      </div>
      <media-image
        :uuid="uuid"
        :format="null"
        :density="1"
        only-img
      />
      <a href="#" class="delete collection-remove collection-action" @click.prevent="deleted" />
      <upload-media-image
        @loading="loading = true"
        @done="loading = false"
        @input="updated"
      />
      <div v-if="loading" class="preview-img__spinner">
        <spinner :size="40" />
      </div>
      <div class="btn upload-media-preview-details__star" role="button" @click="cover">
        <span class="tooltip-inner">{{ trans('media.images.cover') }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import MediaImage from '@components/MediaImage.vue';
import Spinner from '@components/Spinner.vue';
import UploadMediaImage from '@components/UploadMediaImage.vue';
import { trans } from '@elements/translation';

export default {
  components: { Spinner, UploadMediaImage, MediaImage },
  props: {
    index: { type: Number, required: true },
    uuid: { type: String, required: true },
    validating: { type: Boolean, default: false },
  },
  emits: [ 'updated', 'deleted', 'cover' ],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    trans,
    updated(uuid) {
      if (typeof uuid === 'string') {
        this.$emit('updated', this.index, uuid);
      }
    },
    cover() {
      this.$emit('cover', this.index);
    },
    deleted() {
      this.$emit('deleted', this.index);
    },
  },
};

</script>
